import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";
import { Album } from "./album";

export class Playlist extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Playlist' })
    MODELNAME: string;


    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'string' })
    title: string;

    @JsonProperty({ type: 'string' })
    subtitle: string;

    @JsonProperty({ type: 'string?' })
    image_url?: string;

    @JsonProperty({ type: 'boolean' })
    private: boolean;

    @JsonProperty({ type: 'string' })
    type: 'generated' | 'user'

    @JsonProperty({ clazz: Album, type: 'Album' })
    albums: Album[];

    @JsonProperty({ type: 'Date' })
    created_at: Date;

    @JsonProperty({ type: 'Date' })
    updated_at: Date;

    @JsonProperty({ type: 'string?' })
    provider_id?: string
}



// WEBPACK FOOTER //
// ./src/api/src/models/playlist.ts